import React, {useState} from 'react';
import {Button, Spinner} from "reactstrap";


// components
import {showToastCustom} from "../toast/customToast";
import {ButtonCancel} from "../buttons/buttonsActions";

// labels
import {error, infoMsg, saveMsg, success} from "../i18n/i18n";

// services
import {xwitchLogService} from "../../jwt/_services/bi/xwitchLogService";


const ConfirmSyncLogError = ({ onClose }) => {

    const [synchronizing, setSynchronizing] = useState()


    const onSynchronize = () => {
        setSynchronizing(true)

        xwitchLogService.syncErrorType()
            .then( result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                onClose();
            })
            .catch( _ => showToastCustom(error, infoMsg, true))
            .finally( () => {
                setSynchronizing(false)
                onClose()
            })
    }


    return  <div className='custom-ui'>
            <h1>{ "Sincronizar los Errores de log de Xwitch" }</h1>

            <br/>
            <div style={{textAlign:'left'}}>
                    <br/>
                    <br/>
                    <div style={{textAlign:'center'}}>
                        <ButtonCancel onClick={onClose}/>
                        &nbsp;&nbsp;
                        <Button
                            type={"button"}
                            className="btn-add ml-auto ml-2"
                            disabled={ synchronizing }
                            onClick={onSynchronize}
                        >
                            Sincronizar
                        </Button>
                        {
                            synchronizing && <>
                                <br/><br/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                            </>
                        }
                    </div>
            </div>
        </div>
}



export default ConfirmSyncLogError;